// PopupNotificationHandler.jsx
import React from 'react';
import PropTypes from 'prop-types';

import UniversalContainer from '../component/UniversalContainer.jsx';
import ModalView from '../container/ModalView.js';
import {
  POSITION_TOP,
  POSITION_BOTTOM,
  POSITION_CENTER,
  POSITION_FULLSCREEN,
  MODAL_ID_PREFIX,
} from '../resource/popupNotificationConstants.js';
import trackMixpanel, { EventTypes, getViewId } from '../resource/mixpanel.js';
import Delay from '../resource/Delay.js';
import getCurrentUnixTimestamp from '../resource/getCurrentUnixTimestamp.js';

export class PopupNotificationHandler extends React.PureComponent {
  handleClickNotification = ({ tag, type, position, link, exp }) => {
    const { trackEvent } = this.props;
    trackMixpanel({
      type: EventTypes.NOTIFICATION_CLICKED,
      payload: {
        id: tag, // use tag for record not object id
        type,
        position,
        link,
        exp,
        viewId: getViewId({
          pathname: window.location.pathname,
        }),
      },
    });

    trackEvent({
      event: EventTypes.NOTIFICATION_CLICKED,
      properties: {
        'notification.link': link,
        'notification.id': tag, // use tag for record not object id
        'notification.type': type,
        'notification.position': position,
        'notification.exp': exp,
      },
    });
  };

  handleClickNotificationElement = (event, { tag }) => {
    event.stopPropagation();
    const href = event.target.href;
    if (event.target.tagName === 'A' && href) {
      // TODO: add tracking events
      event.preventDefault();
      const isInternalLink = new URL(href).origin === location.origin;
      if (isInternalLink) {
        this.handleClickCloseNotification(tag);
        this.props.push(event.target.getAttribute('href'));
      } else {
        window.open(href, '_blank', 'noopener');
      }
      return;
    }
  };

  handleClickCloseNotification = tag => {
    const { closePopupNotifications, isNotificationCenter } = this.props;

    closePopupNotifications({ notificationTags: [tag], isNotificationCenter });
  };

  fetchNotificationOembedData = () => {
    const { width, height, notificationData, fetchNotificationOembedData } =
      this.props;
    const tag = notificationData?.tag;
    if (width && height) {
      return fetchNotificationOembedData({ tag });
    }
  };

  sendNotificationRead = async () => {
    const {
      sendMeNotificationsRead,
      notificationData,
      timestampOffsetSeconds,
    } = this.props;
    const notificationId = notificationData?.id;
    const exp = notificationData.exp;
    const now = getCurrentUnixTimestamp({
      offsetSeconds: timestampOffsetSeconds,
    });
    const shouldReadNotification = exp === null || (exp && now < exp);
    if (notificationId && shouldReadNotification) {
      const randomDelaySec = Math.floor(Math.random() * 5 + 1) * 1000;
      // Send read notification with random delay 1~5s
      // to smooth the request call server needs to handle
      await new Delay(randomDelaySec).promise();

      return sendMeNotificationsRead({ notificationIds: [notificationId] });
    }
  };
  componentDidMount() {
    const { notificationData } = this.props;
    if (!notificationData.oembed) {
      return this.fetchNotificationOembedData();
    }
    this.sendNotificationRead();
  }

  componentDidUpdate(prevProps) {
    const { width, height } = this.props;
    if (width !== prevProps.width || height !== prevProps.height) {
      this.fetchNotificationOembedData();
    }
  }

  render() {
    const { notificationData, isValid } = this.props;
    if (!isValid) return null;

    const { id, position, tag, exp, link } = notificationData;
    const type = notificationData.oembed?.type;
    const modalId = `${MODAL_ID_PREFIX}${tag}`;

    let filename = '';
    let noScrollLock = false;
    switch (position) {
      case POSITION_TOP:
      case POSITION_BOTTOM:
        filename = 'PopupNotificationTopAndBottom';
        noScrollLock = true;
        break;
      case POSITION_CENTER:
        filename = 'PopupNotificationCenter';
        break;
      case POSITION_FULLSCREEN:
        filename = 'PopupNotificationFullscreen';
        break;
      default:
        return null;
    }

    return (
      <ModalView id={modalId} noScrollLock={noScrollLock}>
        <UniversalContainer
          filename={filename}
          tag={tag}
          notification={notificationData}
          position={position}
          isBottomLayout={position === POSITION_BOTTOM}
          onClickCloseButton={() => this.handleClickCloseNotification(tag)}
          onClickNotification={() => {
            this.handleClickCloseNotification(tag);
            this.handleClickNotification({
              id,
              tag,
              type,
              position,
              link,
              exp,
            });
          }}
          onClickNotificationElement={this.handleClickNotificationElement}
        />
      </ModalView>
    );
  }
}

PopupNotificationHandler.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  notificationData: PropTypes.object,
  isValid: PropTypes.bool,
  isNotificationCenter: PropTypes.bool,
  push: PropTypes.func,
  trackEvent: PropTypes.func,
  closePopupNotifications: PropTypes.func,
  fetchNotificationOembedData: PropTypes.func,
  sendMeNotificationsRead: PropTypes.func,
  timestampOffsetSeconds: PropTypes.number,
};

PopupNotificationHandler.defaultProps = {
  width: null,
  height: null,
  notificationData: {},
  isValid: false,
  isNotificationCenter: false,
  trackEvent: () => null,
  closePopupNotifications: () => null,
  fetchNotificationOembedData: () => null,
  sendMeNotificationsRead: () => null,
  timestampOffsetSeconds: 0,
};

export default PopupNotificationHandler;
